"use strict";

exports.__esModule = true;
exports.buildPageUrl = exports.getLastPage = exports.buildPaginationRequestParams = void 0;

var buildPaginationRequestParams = function buildPaginationRequestParams(page, pageSize, pages) {
  if (pages === void 0) {
    pages = 1;
  }

  if (page !== undefined) {
    return {
      offset: (page - 1) * pageSize,
      size: pageSize * pages,
      limit: pageSize * pages
    };
  }

  return {};
};

exports.buildPaginationRequestParams = buildPaginationRequestParams;

var getLastPage = function getLastPage(entityCount, pageSize) {
  return Math.max(Math.ceil(entityCount / pageSize), 1);
};

exports.getLastPage = getLastPage;

var buildPageUrl = function buildPageUrl(categorySlug, postSlug, page) {
  if (page === void 0) {
    page = 1;
  }

  return page === 1 ? "/" + categorySlug + "/" + postSlug : "/" + categorySlug + "/" + postSlug + "/p-" + page;
};

exports.buildPageUrl = buildPageUrl;